var React = require('react');

function IconShopping (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.5 22.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM18 22.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM21 5.25H4.37L3.75 2.1A.75.75 0 003 1.5H0V3h2.38l2.87 14.4A.75.75 0 006 18h13.5v-1.5H6.62l-.62-3h13.5a.75.75 0 00.75-.59l1.5-6.74a.75.75 0 00-.75-.92zM18.9 12H5.72L4.67 6.75h15.4L18.9 12z"}));
}

IconShopping.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconShopping;

IconShopping.default = IconShopping;
